<div class="container">
    <agm-map *ngIf="config&&config.markerArray&&config.markerArray.length>1" (mapClick)="close_window($event)"
        (mapReady)="onMapReady($event)"
        [latitude]="centerLatitude" [longitude]="centerlongitude" [fitBounds]="true" [zoom]="14"
        [disableDefaultUI]="true" [styles]="myStyles">
        <agm-zoom-control></agm-zoom-control>
        <agm-fullscreen-control *ngIf="!isPrintMode"></agm-fullscreen-control>
        <!-- Direction rendering is now handled programmatically via DirectionRendererService -->
        <agm-marker *ngFor="let marker of config.markerArray;let i = index;"
            (markerClick)=select_marker(marker,infoWindow) [latitude]="marker.latitude" [longitude]="marker.longitude"
            [agmFitBounds]="true" [label]="marker.labelOptions" [iconUrl]="marker.iconOptions" [zIndex]='i+1000'>
            <agm-info-window #infoWindow>
                <tam-dashboard-map-poi [marker]="marker" [id]="id" [isShowEventOnMap]="isShowEventOnMap">
                </tam-dashboard-map-poi>
            </agm-info-window>
        </agm-marker>
    </agm-map>

    <agm-map *ngIf="config&&(!config.markerArray||config.markerArray&&config.markerArray.length<2)"
        (mapClick)="close_window_single($event)" 
        (mapReady)="onMapReady($event)"
        [latitude]="centerLatitude" [longitude]="centerlongitude" [zoom]="14"
        [disableDefaultUI]="true" [styles]="myStyles">
        <agm-zoom-control></agm-zoom-control>
        <agm-fullscreen-control *ngIf="!isPrintMode"></agm-fullscreen-control>
        <!-- Direction rendering is now handled programmatically via DirectionRendererService -->
        <agm-marker *ngFor="let marker of config.markerArray;" [latitude]="marker.latitude" [markerClickable]="true"
            (markerClick)=select_marker_single(marker,infoWindow) [longitude]="marker.longitude"
            [label]="marker.labelOptions" [iconUrl]="marker.iconOptions" [zIndex]='1000'>
            <agm-info-window #infoWindow>
                <tam-dashboard-map-poi [marker]="marker" [id]="id" [isShowEventOnMap]="isShowEventOnMap">
                </tam-dashboard-map-poi>
            </agm-info-window>
        </agm-marker>
    </agm-map>
</div>